import { css } from '@emotion/react'
import LockIcon from '@mui/icons-material/Lock'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import Tooltip from '@mui/material/Tooltip'
import { IntegrationAssignedFilter } from './filter-types'

const deleteIcon = css`
  margin-left: 13px;
  display: flex;
  align-items: center;
  color: #757575;
  width: 25;
`

interface Props {
  filter: IntegrationAssignedFilter
  onFilterDelete: (filter: IntegrationAssignedFilter) => void
  marginTop?: number
  required?: boolean
}

export const DeleteButton = ({ filter, onFilterDelete, marginTop, required }: Props) => {
  return (
    <div css={deleteIcon} style={{ marginTop }}>
      <Tooltip placement="top" title={required ? 'Required Filter' : 'Remove Filter'} arrow>
        {required ? (
          <LockIcon />
        ) : (
          <RemoveCircleIcon
            style={{ cursor: 'pointer' }}
            onClick={() => {
              onFilterDelete(filter)
            }}
          />
        )}
      </Tooltip>
    </div>
  )
}
